module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.a61be33c.eot";